import { Injector } from '@angular/core';

import { UserDTO } from 'psd-common';

export let APP_INJECTOR: Injector;

export class PublicUtil {
    static setInjector(injector: Injector) {
        APP_INJECTOR = injector;
    }

    static getCentralUser(): UserDTO {
        let centralUserJson = localStorage.getItem('user');
        centralUserJson = JSON.parse(centralUserJson);
        return new UserDTO().deserialize(centralUserJson);
    }
}
